import { Component, OnInit } from '@angular/core';
import { LangService } from 'src/app/services/lang/lang.service';
import { SettingsService } from 'src/app/services/site/settings.service';
import { DomSanitizer } from '@angular/platform-browser';
import { CmsService } from 'src/app/services/api/cms.service';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent implements OnInit {

	YCurrent: string = '';

	constructor(
		public lang: LangService,
		public site: SettingsService,
		public cms: CmsService,
		public sanitizer: DomSanitizer
	) { }

	ngOnInit() {
		this.setYCurrent();
		this.cms.getBlock(4, false, false).then(f => {
			this.cms.getBlock(5, false, true).then(f => {
			});
		});
	}

	setYCurrent(){
		let d = new Date();
		this.YCurrent = '' + d.getFullYear();
	}

}
